import { MessageCircle, Mail, ArrowUpRight, type LucideIcon } from "lucide-react";
import { useLingui } from "@lingui/react/macro";
import { toast } from "sonner";

function SupportRow({
  icon: Icon,
  label,
  onClick,
}: {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center justify-between rounded-xl bg-(--sidebar-hover) p-3 text-left transition-opacity hover:opacity-90"
    >
      <span className="flex items-center gap-3">
        <span className="flex size-8 items-center justify-center rounded-md bg-(--color-action)">
          <Icon className="size-[1.125rem] text-white" />
        </span>
        <span className="text-base font-medium text-white">{label}</span>
      </span>
      <ArrowUpRight className="size-5 text-(--gray-400)" />
    </button>
  );
}

export function NeedHelpCard() {
  const { t } = useLingui();
  const notReady = () => toast.info(t`Support channels are coming soon.`);

  return (
    <div className="flex flex-col gap-4 rounded-xl bg-(--color-action) p-4">
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-medium text-white">{t`Need help now?`}</h2>
        <p className="text-sm text-(--gray-400)">
          {t`Contact support for urgent issues.`}
        </p>
      </div>
      <div className="flex flex-col gap-3">
        <SupportRow icon={MessageCircle} label={t`Live chat`} onClick={notReady} />
        <SupportRow icon={Mail} label={t`Email support`} onClick={notReady} />
      </div>
    </div>
  );
}
